import React, { useState } from "react";

import Modal from "./Modal";

const News = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>();
  const [showHighlight, setShowHighlight] = useState<boolean>(true);

  const handleToggleModal = () => setIsModalOpen((prev) => !prev);
  const handleCloseHighlight = () => {
    const wrapper = document.getElementById("wrapper");

    if (wrapper) {
      wrapper.classList.add("closed-highlight");
    }
    setShowHighlight(false);
  };

  if (!showHighlight) return null;

  return (
    <div className="history-news-container">
      <Modal isOpen={isModalOpen} toggle={handleToggleModal} />
      <div className="history-news">
        <div className="history-news__highlight">
          <div className="history-news__highlight__text">
            O VoeBiz está com novas regras e benefícios para sua empresa voar mais alto.
          </div>
          <button className="history-news__highlight__link" onClick={handleToggleModal} type="button">
            Confira o que mudou e aproveite!
          </button>
        </div>
        <button type="button" className="history-news__highlight__close" onClick={handleCloseHighlight}>
          x
        </button>
      </div>
    </div>
  );
};

export default News;
